import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const ClientIntegration = lazy(() => lazyRetry(() => import('containers/ClientIntegration')))

const route = [
  {
    name: i18n.t('routes.clientIntegration.index'),
    path: '/client-integration',
    main: ClientIntegration,
    permissions: ['ROLE_VISUALIZAR_INTEGRACAO_CLIENTE'],
    exact: true
  }
]

export default route
